export default {
    path: '/autorizacao',
    name: 'authorization',
    props: true,
    component: () => import(/* webpackChunkName: "authorization" */ '@/views/authorization/AuthorizationView.vue'),
    meta: {
        title: 'authorization',
        mustHaveCompleteProfile: true,
    },
}